import * as React from "react";
import * as ProgressPrimitive from "@radix-ui/react-progress";

import { cn } from "@/lib/utils";

function Progress({
  className,
  value,
  indicatorClassName,
  indeterminate,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & {
  indicatorClassName?: string;
  indeterminate?: boolean;
}) {
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      // Radix reads a null value as indeterminate, so the announced state
      // matches the animation instead of reporting complete.
      value={indeterminate ? null : value}
      className={cn(
        "bg-blue-500/20 relative h-2 w-full overflow-hidden rounded-full",
        className
      )}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className={cn(
          "bg-blue-500 h-full transition-all",
          // flex-1 is dropped so nothing stretches the third width back to full.
          indeterminate ? "w-1/3 motion-safe:animate-pulse" : "w-full flex-1",
          indicatorClassName
        )}
        style={
          indeterminate
            ? undefined
            : { transform: `translateX(-${100 - (value || 0)}%)` }
        }
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
